import * as Swetrix from 'swetrix'

Swetrix.init('u92oykuZKWR4', {
  apiURL: 'https://swetrix-api.vuetifyjs.com/log',
})
Swetrix.trackViews()
Swetrix.trackErrors()
